import { RoutingFlags } from '@constants/routingFlags';

const VendorsRoute = {
  path: '/vendors',
  load: () => import('./Vendors'),
  protected: true,
  routingFlag: RoutingFlags.VendorManagement,
};

const VendorsDetailsRoute = {
  path: '/vendors/details/:vendorId',
  load: () => import('./vendorDetails/VendorDetails'),
  protected: true,
  routingFlag: RoutingFlags.VendorManagement,
};

const NewVendorsDetailsRoute = {
  path: '/vendors/details',
  load: () => import('./vendorDetails/VendorDetails'),
  protected: true,
  routingFlag: RoutingFlags.VendorManagement,
};

export { NewVendorsDetailsRoute, VendorsDetailsRoute, VendorsRoute };
